import { render, staticRenderFns } from "./alert-toast-success.vue?vue&type=template&id=2b51b35c&"
import script from "./alert-toast-success.vue?vue&type=script&lang=js&"
export * from "./alert-toast-success.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports